import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RatingIcon } from './../feedback.model';
import { FeedbackService } from './../feedback.service';

@Component({
  selector: 'feedback-rating',
  templateUrl: './feedback-rating.component.html',
  styleUrls: ['./feedback-rating.component.scss'],
})
export class FeedbackRatingComponent implements OnInit {
  @Input() ratingTitle;
  @Output() ratings: EventEmitter<number> = new EventEmitter();
  iconList: RatingIcon[];

  currentRatings = 0;

  constructor(private feedbackService: FeedbackService) {}

  ngOnInit(): void {
    this.iconList = this.feedbackService.createIconList();
  }

  changeIcons(i: number) {
    this.currentRatings = i + 1;
    const updatedIcons = this.iconList.map((icon, index) => ({
      ...icon,
      text: index <= i ? 'star_active' : 'star',
    }));

    this.iconList = [...updatedIcons];
    this.ratings.emit(this.currentRatings);
  }
}
